export const FETCH_DEAL = 'fetchDeal'
export const FETCH_DEALS = 'fetchDeals'
export const DEAL_RESET_STATE = 'dealResetState'
export const FETCH_DEALS_BY_CLIENT = 'dealsByClient'
export const FETCH_DEALS_BY_MONTH = 'dealsByMonth'

export const FETCH_USER = 'fetchUser'
export const FETCH_USERS = 'fetchUsers'
export const FETCH_PARTNER = 'fetchPartner'
export const USER_RESET_STATE = 'userResetState'